// White-label branding — update only (branding is read from auth session user.branding).
import { invokeApi } from '../bl_libs/invokeApi';
import { LOCAL_STORAGE_KEYS } from '../utils/constants';

const authHeaders = () => ({
    Authorization: `Bearer ${JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token))}`,
});

/**
 * Update branding for this workspace.
 * @param {{
 *   colors?: object,
 *   fonts?: object,
 *   font_uploads?: object,
 *   custom_stylesheet?: string|null,
 *   stylesheet_upload?: object,
 *   logo_url?: string|null,
 *   image_base64?: string,
 *   mime_type?: string,
 * }} payload
 */
export const updateBrandingService = ({
    colors,
    fonts,
    font_uploads,
    custom_stylesheet,
    stylesheet_upload,
    logo_url,
    image_base64,
    mime_type,
} = {}) => {
    const postData = {};
    if (colors !== undefined) postData.colors = colors;
    if (fonts !== undefined) postData.fonts = fonts;
    if (font_uploads !== undefined) postData.font_uploads = font_uploads;
    if (custom_stylesheet !== undefined) postData.custom_stylesheet = custom_stylesheet;
    if (stylesheet_upload !== undefined) postData.stylesheet_upload = stylesheet_upload;
    if (logo_url !== undefined) postData.logo_url = logo_url;
    if (image_base64 !== undefined) postData.image_base64 = image_base64;
    if (mime_type !== undefined) postData.mime_type = mime_type;
    return invokeApi({
        path: '/dq_insider/auth/dqin/branding/update',
        method: 'POST',
        headers: authHeaders(),
        postData,
    });
};
